import { asMoney } from "../../../../Bfs.Web.Data.Service.Contracts/Shared.fs.js";
import { sortByDescending, map, isEmpty, singleton as singleton_1, sortBy, ofArray } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { desktopDataTable, mobileDataList } from "../Shared/DataList.fs.js";
import { comparePrimitives, compareArrays } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { bfsCard, bfsCardCollapsable } from "../Shared/Card.fs.js";
import { spinner } from "../../../../Bfs.Web.Portale/ViewParts.fs.js";
import { singleton, append, delay } from "../../../fable_modules/fable-library-js.4.19.0/Seq.js";
import * as react from "react";
import { DashboardPage } from "../DashBoardPage.fs.js";

export const columnMapping = ofArray([["RechnungsNr", (row) => row.RechnungsNrExtern], ["Klient/Patient", (row_1) => row_1.KlientPatient], ["Leistungsgrundlage", (row_2) => row_2.LeistungsGrundlage], ["Rechnungsbetrag", (row_3) => asMoney(row_3.Rechnungsbetrag)], ["Meldung", (row_4) => row_4.Meldung]]);

export function mobileTable(data) {
    return mobileDataList("Hier werden Sie zukünftig Ihre aktuelle Sendung mit den angekauften Belegen sehen.", columnMapping, sortBy((row) => [row.KlientPatient, row.LeistungsGrundlage], data, {
        Compare: compareArrays,
    }));
}

export function desktopTable(data) {
    return desktopDataTable("Hier werden Sie zukünftig Ihre aktuelle Sendung mit den angekauften Belegen sehen.", columnMapping, sortBy((row) => [row.KlientPatient, row.LeistungsGrundlage], data, {
        Compare: compareArrays,
    }));
}

function SendungList(sendungsNr, data) {
    return bfsCardCollapsable([`Sendung ${sendungsNr}`, ofArray([mobileTable(data), desktopTable(data)]), false]);
}

export function view(model, _arg, navigateTo) {
    if (model.Loading) {
        return spinner;
    }
    else {
        return Array.from(delay(() => {
            let children_2;
            return append(singleton(bfsCard(singleton_1((children_2 = [react.createElement("i", {
                className: "fas fa-angle-left mr-2",
            }), "Zurück zum Dashboard"], react.createElement("a", {
                onClick: (_arg_1) => {
                    navigateTo(new DashboardPage());
                },
            }, ...children_2))), undefined)), delay(() => (isEmpty(model.Data) ? singleton_1(bfsCard(undefined, singleton_1("Wir freuen uns auf Ihre erste Sendung!"))) : map((data) => SendungList(data.SendungNr, data.Rechnungen), sortByDescending((x) => x.SendungNr, model.Data, {
                Compare: comparePrimitives,
            })))));
        }));
    }
}

//# sourceMappingURL=View.fs.js.map
